<template>
  <div
    class="field-wrapper field-wrapper--email"
    :class="[field.cssClass, {'visually-hidden': field.visibility === 'hidden'}, 'field-wrapper--' + field.size]"
  >
    <div
      class="field-group field-group--block field-group--block-gray"
      :class="[{'field-group--is-error': isError}]"
    >
      <label
        :for="'input_' + formId + '_' + field.id"
        class="label"
        :class="[{'visually-hidden': field.labelPlacement === 'hidden_label'}]"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </label>
      <input
        :id="'input_' + formId + '_' + field.id"
        :name="'input_' + field.id"
        v-model="text"
        @focus="inputFocus"
        @blur="inputBlur"
        :required="field.isRequired"
        :placeholder="field.labelPlacement === 'hidden_label' ? field.placeholder : null"
        type="email"
      >
    </div>

    <slot name="description"></slot>
    <slot name="error"></slot>
  </div>
</template>

<script>
import store from '../store';
import VFieldMixins from './VFieldMixins.vue';
export default {
  store,
  name: "VFieldEmail",
  mixins: [VFieldMixins],
  data () {
    return {
      text: '',
    }
  },

  mounted() {

  },

  props: {
    formId: Number,
    field: Object,
    fieldKey: Number,
    isError: String,
  },
  watch: {
    text: {
      immediate: true,
      deep: false,
      handler (newValue) {
        store.commit(
            'UPDATE_USER_FORM_DATA' ,
            {'key': this.field.id, 'value': newValue})
      }
    }
  }

}
</script>
